export const START_TIMER = "START TIMER";
export const STOP_TIMER = "STOP TIMER";
export const RESET_TIMER = "RESET TIMER";
